import { FC } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
// Components
import Dialog from 'components/Dialog';
import Video from 'components/Video';

type Props = {
  onClose: () => void;
}

const PromoVideoDialog:FC<Props> = ({ onClose }) => {
  const quiz = useAppSelector(selectQuiz);

  return (
    <Dialog classes="p-4">
      <div className="flex-1 flex items-center">
        <div className="shadow-primary rounded-lg overflow-hidden">
          <Video
            videoUrl={quiz?.promoVideo}
            onEndedCallback={onClose}
          />
        </div>
      </div>
    </Dialog>
  )
}

export default PromoVideoDialog;
